import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är en sanktionsavgift och när tas den ut?";
const SHORT_ANSWER = "En administrativ avgift som kommunen kan besluta om vid överträdelser enligt 9 kap. 17 a § alkohollagen. Beloppet ligger normalt mellan 5 000 och 250 000 kr.";

export const Route = createFileRoute("/fraga/nar-leder-sanktionsavgift")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är en sanktionsavgift och när tas den ut" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Sanktionsavgift kan kombineras med varning, men inte med återkallelse. Tanken är att kunna träffa även mindre allvarliga överträdelser proportionellt."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Sanktionsavgifter – komplett guide" }}
      related={[{"to": "/fraga/vad-galler-vid-misstankt-narkotikahandel", "label": "Vad gäller om jag misstänker narkotikahandel i lokalen?"}, {"to": "/fraga/vad-galler-vid-vald-pa-stallet", "label": "Vad gäller om det inträffar våld på serveringsstället?"}, {"to": "/fraga/hur-overklagar-jag-ett-beslut", "label": "Hur överklagar jag ett beslut om serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är en sanktionsavgift och när tas den ut?" },
      { name: "description", content: "En administrativ avgift som kommunen kan besluta om vid överträdelser enligt 9 kap. 17 a § alkohollagen. Beloppet ligger normalt mellan 5 000 och 250 000 kr." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/nar-leder-sanktionsavgift" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/nar-leder-sanktionsavgift" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/nar-leder-sanktionsavgift",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är en sanktionsavgift och när tas den ut", url: "https://alkoholprovet.se/fraga/nar-leder-sanktionsavgift" },
      ]),
    ],
  }),
});
